import { Link, useLocation } from "react-router-dom";
import { HomeIcon, UsersIcon } from "@heroicons/react/outline";
import MainLogo from "../images/CarboMain-Logo.svg";
import { GiPlantRoots, GiToken } from "react-icons/gi";
import { MdOutlineGeneratingTokens, MdOutlineDashboard } from "react-icons/md";
import { AiOutlineTransaction, AiOutlineYoutube } from "react-icons/ai";
import TopBar from "./TopBar";

function Sidebar({ setSidebarOpen }) {
  const { pathname } = useLocation();

  const navigation = [
    {
      name: "Dashboard",
      href: "/",
      icon: MdOutlineDashboard,
      current: pathname === "/" ? true : false,
    },
    {
      name: "Buy Token",
      href: "/buy-tokens",
      icon: MdOutlineGeneratingTokens,
      current: pathname === "/buy-tokens" ? true : false,
    },
    {
      name: "Burn Token",
      href: "/burn-tokens",
      icon: GiToken,
      current: pathname === "/burn-tokens" ? true : false,
    },
    {
      name: "Transaction",
      href: "/transactions",
      icon: AiOutlineTransaction,
      current: pathname === "/transactions" ? true : false,
    },
    // {
    //   name: "Dummy Video",
    //   href: "/",
    //   icon: AiOutlineYoutube,
    //   // current: pathname === "/video" ? true : false,
    // },
  ];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="side-drawer">
        <div className="outer-wrapper">
          <a className="logo-wrapper" href="/">
            <img src={MainLogo} alt="emertech logo" />
            <h4>Carbo-X</h4>
          </a>
          <div className="menu-wrapper">
            <nav>
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    item.current
                      ? "active"
                      : "",
                    "group flex items-center"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "active"
                        : "",
                      "h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  <span>{item.name}</span>
                </Link>
              ))}
            </nav>
          </div>
          <TopBar setSidebarOpen={setSidebarOpen} />
        </div>
      </div>
    </>
  );
}

export default Sidebar;
